module.exports = __webpack_public_path__ + "TextaNarrow-Regular-webfont.7f502d7c65691537821e.eot";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/TextaNarrow-Regular-webfont.eot
// module id = ../../../../../src-admin/assets/fonts/TextaNarrow-Regular-webfont.eot
// module chunks = styles